export default __webpack_public_path__ + "static/media/youtube-icon.fda044e1.png";